<template>
  <div
    :class="{'show': sidebarShow}"
    class="col-md-3 px-0 border-right position-fixed h-100 bg-white no-scrollbar course-sidebar"
    ref="course-sidebar"
  >
    <div class="text-primary">
      <div id="sticky-course-header"
        class="py-5 px-xl-5 px-lg-4 px-3 sticky-top course-title-bg border-bottom">
        <h4>{{ courseName }}</h4>
        <div class="d-flex align-items-center" v-if="completedPercent > -1">
          <p class="d-inline-block mr-3 mb-0 font-weight-bold text-nowrap">
            {{ completedPercent }} %
          </p>
          <progress :value="completedPercent" max="100" class="custom-progress"></progress>
        </div>
      </div>
      <div class="list-group rounded-0 border-0" id="categoryList">
        <div v-for="chapter in activePosts(chapterList)" :key="chapter.id">
          <a
            :href="'#chapter' + chapter.id"
            class="text-secondary px-xl-5 px-lg-4 px-3 custom-collapse-icon
            list-group-item list-group-item-action
            border-right-0 border-top-0 d-flex justify-content-between"
            data-toggle="collapse"
            role="button"
            :class="{'collapsed': chapterId !== chapter.id}"
            @click="gaTrackEvent('Lesson', 'Click Course Menu', chapter.name)"
          >
            {{ chapter.name }}
            <span
              class="material-icons fa-chevron-up text-primary"
            >keyboard_arrow_up</span>
            <span class="material-icons fa-chevron-down text-primary">keyboard_arrow_down</span>
          </a>
          <div
            class="collapse rounded-0"
            :id="'chapter' + chapter.id"
            :class="{'show': chapterId == chapter.id}"
          >
            <div class="list-group rounded-0 border-0" v-if="chapterId == chapter.id">
              <a :href="'/course/' + courseId + '/chapter/' + chapterPathVar
                + '/post/' + lecture.path_var"
                v-for="lecture in nowPosts"
                :key="lecture._id"
                :id="'lecture' + lecture._id"
                class="lecture-item px-xl-5 px-lg-4 px-3
                  border-0 list-group-item list-group-item-action d-flex align-items-start"
                :class="{'active': lecture._id == postId}"
              >
                <span class="material-icons mr-2">{{ checkLectureStatus(lecture._id) }}</span>
                <p class="mb-0">{{ lecture.name }}</p>
              </a>
            </div>
            <div class="list-group rounded-0 border-0" v-else>
              <a
                :href="'/course/' + courseId + '/chapter/' + chapter.path_var
                  + '/post/' + lecture.path_var"
                v-for="lecture in postSort(activePosts(chapter.posts))"
                :key="lecture.id"
                class="lecture-item px-xl-5 px-lg-4 px-3 border-0
                  list-group-item list-group-item-action d-flex align-items-start"
                :class="{'active': lecture.id == postId}"
              >
                <span class="material-icons mr-2">{{ checkLectureStatus(lecture.id) }}</span>
                <p class="mb-0">{{ lecture.name }}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'courseSidebar',
  props: {
    courseId: String,
    courseName: String,
    postId: String,
    chapterId: String,
    chapterPathVar: String,
    posts: String, // 避免選單收縮，當下的 chapter 用 blade 參數傳
  },
  data() {
    return {
      coursesData: {},
      nowPosts: JSON.parse(this.posts)
        .filter((post) => post.active)
        .sort(
          (a, b) => this.parseToTimeStamp(a.opened_at)
            - this.parseToTimeStamp(b.opened_at),
        ),
      chapterList:
        JSON.parse(
          window.sessionStorage.getItem(`biz_thinking_${this.courseId}`),
        ) || [],
      coursesOptions: [],
      sidebarShow: false,
    };
  },
  methods: {
    getCourseData() {
      const vm = this;
      axios.get(`/api/course/${vm.courseId}`).then((res) => {
        vm.coursesData = res.data.data;
        vm.$emit('courseData', res.data.data);
        vm.chapterList = res.data.data.chapters.sort((a, b) => a.sort - b.sort);
        const storageData = [];
        vm.chapterList.forEach((chapter) => {
          const postData = [];
          vm.postSort(chapter.posts).forEach((post) => postData.push({
            id: post.id,
            name: post.name,
            path_var: post.path_var,
          }));
          storageData.push({
            active: chapter.active,
            id: chapter.id,
            name: chapter.name,
            path_var: chapter.path_var,
            sort: chapter.sort,
            posts: postData,
          });
        });
        window.sessionStorage.setItem(
          `biz_thinking_${vm.courseId}`,
          JSON.stringify(storageData),
        );
      });
    },
    getOptions() {
      const vm = this;
      axios.get(`/api/course/${vm.courseId}/options`).then((res) => {
        vm.coursesOptions = res.data.data.options;
        vm.nowPostCompleteStatus();
      });
    },
    checkLectureStatus(postID) {
      if (
        this.coursesOptions
        && Object.prototype.hasOwnProperty.call(this.coursesOptions, 'completed')
      ) {
        if (
          this.coursesOptions.completed.some((item) => item.post.id === postID)
        ) {
          return 'check_circle';
        }
      }
      if (this.coursesOptions && Object.prototype.hasOwnProperty.call(this.coursesOptions, 'read')) {
        if (this.coursesOptions.read.some((item) => item.post.id === postID)) {
          return 'timelapse';
        }
      }
      return 'radio_button_unchecked';
    },
    activePosts(posts) {
      return posts.filter((post) => post.active);
    },
    nowPostCompleteStatus() {
      const vm = this;
      vm.$emit('completedStatus', vm.checkLectureStatus(vm.postId));
    },
  },
  computed: {
    completedPercent() {
      const allPosts = [];
      const vm = this;
      if (this.chapterList && this.chapterList.length > 0) {
        this.chapterList.forEach((chapter) => vm
          .checkItemActive(chapter.posts)
          .forEach((post) => allPosts.push(post)));
        if (
          this.coursesOptions.completed
          && this.coursesOptions.completed.length > 0
        ) {
          const uniqCompleted = this.coursesOptions.completed.filter(
            (v, i, a) => a.findIndex((p) => p.post.id === v.post.id) === i,
          );
          const checkPostNotDelete = [];
          uniqCompleted.forEach((post) => {
            if (allPosts.some((allpost) => allpost.id === post.post.id)) {
              checkPostNotDelete.push(post);
            }
          });
          return parseInt((checkPostNotDelete.length / allPosts.length) * 100, 10);
        }
        return 0;
      }
      return 0;
    },
  },
  watch: {
    $route() {
      // this.nowID = this.$route.params.id;
      this.sidebarShow = false;
      $('body').removeClass('sidebar-open');
      this.$bus.$emit('closeBar', { param: 'openSidebar', status: false });
    },
  },
  mounted() {
    const vm = this;
    vm.getCourseData();
    vm.getOptions();
    const stickyOffsetHeight = document.getElementById('sticky-course-header').offsetHeight;
    const topOfElement = document.getElementById(`lecture${vm.postId}`).offsetTop - stickyOffsetHeight;
    document.querySelector('.course-sidebar').scrollTo({ top: topOfElement, behavior: 'smooth' });
    this.$bus.$on('openSidebar', (data) => {
      if (data) {
        vm.sidebarShow = data;
        $('body').addClass('sidebar-open');
      } else {
        vm.sidebarShow = data;
        $('body').removeClass('sidebar-open');
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.list-group-item.active {
  margin-top: 0px;
}
.custom-collapse-icon {
  .fa-chevron-up {
    display: inline-block;
  }
  .fa-chevron-down {
    display: none;
  }
}
.custom-collapse-icon.collapsed {
  .fa-chevron-up {
    display: none;
  }
  .fa-chevron-down {
    display: inline-block;
  }
}
</style>
